import { getDecimalNumber } from 'utility/Format/Number';
import i18n from 'utility/Translate/I18n';

const getMetricType = (distance: number, hasDecimals: boolean) => {
    if (distance < 1000 && !hasDecimals) {
        return i18n.t('TRANS-distance-metric-meter');
    }

    return i18n.t('TRANS-distance-metric-kilometer');
};

export const getDistanceFormat = (
    distance: number,
    round = false,
    hasDecimals = true
) => {
    const value =
        distance > 1000 || hasDecimals
            ? getDecimalNumber(Math.max(distance, 100) / 1000, round ? 0 : 1)
            : distance;
    const metric = getMetricType(distance, hasDecimals);

    return `${value} ${metric}`;
};
